const ruCommon = {
  site: {
    title: 'YOYBUY Spreadsheet',
    subtitle: 'Ваш умный гид по покупкам из Китая',
    description: 'Организуйте покупки из Китая профессионально с помощью YOYBUY Spreadsheet — таблицы, которые экономят время и деньги.',
  },
  nav: {
    home: 'Главная',
    shoppingGuide: 'Гид покупок',
    buyNow: 'Купить сейчас',
    menu: 'Меню',
    yoybuySheet: 'YOYBUY Sheet',
  },
  hero: {
    heading: 'Покупайте из Китая как профессионал',
    subheading: 'YOYBUY Spreadsheet — инструмент, который упрощает поиск, сравнение и заказ товаров из Китая. Всё в одной таблице.',
    ctaYoybuy: 'YOYBUY Sheet',
    ctaBuyNow: 'Купить сейчас',
    trusted: 'Более 5000 довольных покупателей',
  },
  categories: {
    title: 'Категории товаров',
    subtitle: 'Выберите категорию и начните покупки прямо сейчас',
    placeholder: 'Выберите категорию...',
    shoes: 'Обувь',
    hoodies: 'Худи / Свитера',
    tshirts: 'Футболки',
    jackets: 'Куртки',
    pants: 'Штаны / Шорты',
    headwear: 'Головные уборы',
    sets: 'Комплекты',
    underwear: 'Нижнее бельё',
    jersey: 'Джерси',
    accessories: 'Аксессуары',
    bags: 'Сумки',
    belts: 'Ремни',
    perfumes: 'Парфюмерия',
    other: 'Другое',
  },
  articlesSection: {
    title: 'Руководства по покупкам из Китая',
    subtitle: 'Полезные статьи и руководства для успешных покупок из Китая. Узнайте всё о TaoBao, 1688, доставке и сравнении агентов.',
    readMore: 'Читать далее',
    viewAll: 'Все руководства',
  },
  article: {
    previewTitle: 'Руководство по покупкам из Китая',
    previewSubtitle: 'Узнайте, как YOYBUY Spreadsheet помогает экономить до 40% на закупках из Китая',
    previewExcerpt: 'Полное руководство по использованию таблиц для организации покупок из Китая. Сравнение агентов, расчёт стоимости доставки, поиск лучших цен на TaoBao и 1688 — всё это в YOYBUY Spreadsheet. Узнайте, как профессионалы управляют закупками из Китая с помощью одного инструмента.',
    readMore: 'Читать руководство',
  },
  footer: {
    copyright: '© 2026 YOYBUY Spreadsheet. Все права защищены.',
    disclaimer: 'YOYBUY Spreadsheet является независимым инструментом. Все товарные знаки принадлежат их владельцам.',
    links: 'Полезные ссылки',
    homeLink: 'На главную',
    guideLink: 'Руководство',
    shoppingGuideLink: 'Гид покупок',
  },
  articlePage: {
    backHome: '← На главную',
    intro: 'Покупки из Китая становятся всё более популярными среди покупателей по всему миру. TaoBao, 1688, Weidian — миллионы товаров по привлекательным ценам. Но как не запутаться в тысячах продавцов, правильно рассчитать доставку и не переплатить посредникам? Ответ — YOYBUY Spreadsheet.',
    relatedTitle: 'Связанные категории',
    notFound: 'Статья не найдена',
    notFoundDesc: 'Запрошенное руководство не существует или было перемещено.',
  },
};

export default ruCommon;